import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { ConfirmationDialogComponent } from "app/modules/masters/adptive-ui-management/confirmation-dialog/confirmation-dialog.component";
import { MatDialog } from "@angular/material/dialog";

export interface AppWideAlertModel {
  message: string;
  duration?: number;
}

@Injectable({
  providedIn: "root",
})
export class AppWideAlertService {
  constructor(private dialog: MatDialog) {}

  public $successAlertObservable: BehaviorSubject<AppWideAlertModel> = new BehaviorSubject<AppWideAlertModel>({ message: "" });

  public $errorAlertObservable: BehaviorSubject<AppWideAlertModel> = new BehaviorSubject<AppWideAlertModel>({ message: "" });

  success(message: string) {
    this.$successAlertObservable.next({ message: message, duration: 5000 });
  }

  successWithDuration(message: string, durationInMilliSeconds: number) {
    this.$successAlertObservable.next({ message: message, duration: durationInMilliSeconds });
  }

  error(message: string) {
    this.$errorAlertObservable.next({ message: message, duration: 5000 });
  }

  errorWithDuration(message: string, durationInMilliSeconds: number) {
    this.$errorAlertObservable.next({ message: message, duration: durationInMilliSeconds });
  }

  confirm(message: string): Observable<boolean> {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: "350px",
      data: { message },
    });

    return dialogRef.afterClosed();
  }
}
